/**
 * usePanelStates Hook
 * Manage floating panel visibility states
 */

import { useState } from 'react'

export function usePanelStates() {
  // Floating panel states
  const [isMaterialPanelOpen, setIsMaterialPanelOpen] = useState(false)
  const [isExportPanelOpen, setIsExportPanelOpen] = useState(false)
  const [isLightsPanelOpen, setIsLightsPanelOpen] = useState(false)
  const [isAnimationPanelOpen, setIsAnimationPanelOpen] = useState(true) // Default open
  const [isHistoryPanelOpen, setIsHistoryPanelOpen] = useState(true)
  const [isUvMapPanelOpen, setIsUvMapPanelOpen] = useState(false)
  const [isPanelCollapsed, setIsPanelCollapsed] = useState(false)

  // Panel section states (collapsible sections dalam panels)
  const [materialSections, setMaterialSections] = useState({
    shader: false, // Collapsed by default
    essential: true, // Expanded by default
    advanced: false,
  })

  const [isVideoSettingsExpanded, setIsVideoSettingsExpanded] = useState(true)
  const [isCameraAnimationExpanded, setIsCameraAnimationExpanded] = useState(true)

  return {
    // Panel visibility
    isMaterialPanelOpen,
    setIsMaterialPanelOpen,
    isExportPanelOpen,
    setIsExportPanelOpen,
    isLightsPanelOpen,
    setIsLightsPanelOpen,
    isAnimationPanelOpen,
    setIsAnimationPanelOpen,
    isHistoryPanelOpen,
    setIsHistoryPanelOpen,
    isUvMapPanelOpen,
    setIsUvMapPanelOpen,
    isPanelCollapsed,
    setIsPanelCollapsed,

    // Section states
    materialSections,
    setMaterialSections,
    isVideoSettingsExpanded,
    setIsVideoSettingsExpanded,
    isCameraAnimationExpanded,
    setIsCameraAnimationExpanded,
  }
}

